function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/*
 * This file is part of the nivo project.
 *
 * Copyright 2016-present, Raphaël Benitte.
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */
import React from 'react';
import { ResponsiveWrapper } from '@nivo/core';
import Pie from './Pie';

const ResponsivePie = props => React.createElement(ResponsiveWrapper, null, ({
  width,
  height
}) => React.createElement(Pie, _extends({
  width: width,
  height: height
}, props)));

export default ResponsivePie;